import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import TrustContent from '@/components/feature/TrustContent';
import { useJsonLd } from '@/hooks/useJsonLd';
import { aboutPage } from '@/mocks/trustPages';

export default function AboutPage() {
  const { i18n } = useTranslation();
  const lang = aboutPage[i18n.language] ? i18n.language : 'en';
  const page = aboutPage[lang];

  useJsonLd({
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: page.title,
    description: page.metaDescription,
    url: `${import.meta.env.VITE_SITE_URL}/about`,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <TrustContent page={page} />
      </main>
      <Footer />
    </div>
  );
}